import { Controller } from 'core/Controller';
import { Events } from 'core/events/Events';
import { AppEvents } from 'app/events/AppEvents';
import { HistoryStateModel } from 'app/model/HistoryStateModel';
import SiteTransitions from 'app/services/SiteTransitions';
import { Simple } from 'utils/analytics';
import { ScrollbarController } from 'app/chrome/scrollbar/ScrollbarController';
/** @class Controller to manage history state elements  */
export class HistoryController extends Controller {
	private _currentState: HistoryStateModel; //The current state of the website
	private _initalState: HistoryStateModel; //The intial state webite for the page that loads directly
	private _onIntialState: boolean = true;

	/** As a global controller init will be called on load. So set the intial state. Used when back takes to intial page  website */
	public init(): void {
		//Add listener for popstate:
		window.onpopstate = this._onPop.bind(this);
	}

	public setControllers(scrollbar: ScrollbarController) {
	}

	/**
	 * Set intial state loadup. Comes from View controller init > event as  logic for working out where loaded is bit tricky to make fully modular
	 * @param {HistoryStateModel} stateObject - State object to rebuild the view from
	 */
	public setIntialState(stateObject: HistoryStateModel): void {
		this._initalState = stateObject;
	}

	/**
	 * Add a history state in (Because of section change event)
	 * @param {HistoryStateModel} stateObject - State object to rebuild the view from
	 * @param {string} title - Title of the page.
	 * @param {string} string - new page url to switch to.
	 */
	public push(stateObject: HistoryStateModel, title: string, url: string): void {
		this._onIntialState = false;

		if (this._currentState && this._currentState.href === url) {
			return;
		}

		window.history.pushState(stateObject, this._getFullTitle(title), url);
		document.title = this._getFullTitle(title);

		if ((window as any).ga) {
			(window as any).ga('set', 'page', url);
			(window as any).ga('send', 'pageview');
		}

		this._currentState = stateObject;
	}

	//PRIVATE
	//----------------------------------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------------------------------

	/** User inicated back or forward navigation */
	private _onPop(e) {

		SiteTransitions.historyStateChange();

		let fromSection = null;
		let fromSubSection = null;
		let fromHref = null;
		if (this._currentState) {
			fromSection = this._currentState.section;
			fromSubSection = this._currentState.subsection;
			fromHref = this._currentState.href;
		}

		this._currentState = window.history.state !== null ? window.history.state : this._initalState;

		Events.dispatch(AppEvents.POP_HISTORY_STATE, this._currentState);

		Simple.event('history_state_pop', {
			to_section: this._currentState.section,
			to_sub_section: this._currentState.subsection,
			to_href: this._currentState.href,
			from_section: fromSection,
			from_sub_section: fromSubSection,
			from_href: fromHref
		});

		if (!window.history.state && this._onIntialState) {
			return false;
		} else if (!window.history.state && !this._onIntialState) {
			this._onIntialState = true;
		} else {
			this._onIntialState = false;
		}
	}

	/** Get full combined title */
	private _getFullTitle(post: string): string {
		return `DEBUG | ${post}`;
	}
}
